export const initialState = {
  months: 3,
  expenses: {
    children: 0,
    food: 0,
    housing: 0,
    transport: 0,
    other: 0,
  },
  result: 0,
  submitted: false,
}

export const actions = {
  INPUT_MONTHS: 'inputMonths',
  INPUT_EXPENSE: 'inputExpense',
  SUBMIT: 'submit',
  CLEAR: 'clear',
}

const calculateResult = state =>
  Object.values(state.expenses).reduce((a, b) => a + (b || 0), 0) * state.months

export const reducer = (state, action) => {
  switch (action.type) {
    case actions.INPUT_MONTHS:
      return { ...state, months: action.payload }
    case actions.INPUT_EXPENSE:
      return {
        ...state,
        expenses: {
          ...state.expenses,
          [action.payload.type]: action.payload.value,
        },
      }
    case actions.SUBMIT: {
      return { ...state, result: calculateResult(state), submitted: true }
    }
    case actions.CLEAR: {
      return initialState
    }
    default:
      return state
  }
}
